import * as HLF from "html-living-framework";
import {Anchor} from "../core/Anchor";
import {Animatable} from "../core/Animatable";
import {texture} from "../core/AssetHelpers";
import {Callback, Mix} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {Focusables} from "../gameobjects/Focusables";
import {MuteButton} from "../gameobjects/MuteButton";

export class StoryLoadScreen extends HLF.LoadScreen {

    public static readonly NAME = "StoryLoadScreen";

    public readonly bg = this.addChild(new Sprite(PIXI.Texture.WHITE, Anchor.middleCenter));
    public readonly loader = this.addChild(new (Mix(PIXI.extras.AnimatedSprite, Animatable))((() => {
        const textures = [];
        for (let i = 1; ; i++) {
            const t = texture(`loop${("000" + i.toString()).slice(-4)}.jpg`);
            if (t) {
                textures.push(t);
            } else {
                break;
            }
        }
        return textures;
    })()));
    public buttonMute?: MuteButton;

    private _onLoaded?: Callback;
    private _isAnimatedIn = false;

    public init(pSize: PIXI.Point) {
        super.init(pSize);

        this._isAnimatedIn = false;
        this._onLoaded = undefined;

        // this.loader.scale.set(2);
        this.loader.animationSpeed = 0.2;
        this.loader.loop = true;
        this.loader.alphaFrom(0, 0.2, () => {
            this.loader.delayedCall(0.4, () => {
                this._isAnimatedIn = true;
                this.hideLoader();
            });
        });
        this.loader.play();

        if (this.buttonMute) {
            this.buttonMute.destroy();
        }
        this.buttonMute = this.addChild(new MuteButton());
        this.buttonMute.setPosition(this._size);

        Focusables.clear();
        Focusables.add(this.buttonMute);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);

        this.bg.width = this._size.x + 10;
        this.bg.height = this._size.y + 10;

        if (this.buttonMute) {
            this.buttonMute.setPosition(this._size);
        }
    }

    public onLoadComplete(pCallback: () => void): void {
        this._onLoaded = pCallback;
        this.hideLoader();
    }

    private hideLoader() {
        if (this._isAnimatedIn && this._onLoaded) {
            this.loader.alphaTo(0, 0.2, () => {
                if (this._onLoaded) {
                    this._onLoaded();
                }
            });
        }
    }
}
